function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.09 2c-1.434 0-2.74.497-3.661 1.403C.506 4.308 0 5.603 0 7.09c0 2.516 1.542 4.393 3.299 5.974 1.756 1.581 3.805 2.98 5.195 4.623.152.192.38.306.623.312h.052a.824.824 0 00.623-.312c1.39-1.642 3.438-3.042 5.195-4.623 1.757-1.581 3.299-3.458 3.299-5.974 0-1.487-.533-2.783-1.455-3.688C15.91 2.497 14.63 2 13.195 2c-1.422 0-2.588.776-3.403 1.48-.4.345-.419.439-.65.702-.226-.263-.25-.357-.648-.701C7.682 2.776 6.513 2 5.09 2zm0 1.662c.783 0 1.657.523 2.313 1.091A7.942 7.942 0 018.468 5.87c.155.218.409.348.675.348.266 0 .52-.13.675-.348 0 0 .406-.549 1.065-1.117.66-.568 1.526-1.09 2.312-1.09 1.068 0 1.909.363 2.493.934.585.572.935 1.38.935 2.494 0 1.84-1.113 3.25-2.753 4.727-1.451 1.309-3.224 2.65-4.727 4.234-1.507-1.591-3.273-2.925-4.727-4.234-1.64-1.477-2.754-2.886-2.754-4.727 0-1.114.351-1.922.935-2.494.585-.571 1.422-.935 2.494-.935z",
  fill: "#41D496"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 9h9v8h-9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.58 15.52h1.62v-2.04h2.052v-1.608H16.2V9.808h-1.62v2.064h-2.052v1.608h2.052v2.04z",
  fill: "#41D496"
});

function SvgHeartPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgHeartPlus;